module.exports = __webpack_public_path__ + "skinscreening-mobile___18zH7.svg";